import { render, staticRenderFns } from "./error-404.vue?vue&type=template&id=4c374d67&scoped=true&lang=html"
import script from "./error-404.vue?vue&type=script&lang=js"
export * from "./error-404.vue?vue&type=script&lang=js"
import style0 from "./error-404.vue?vue&type=style&index=0&id=4c374d67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c374d67",
  null
  
)

export default component.exports